<!--
  倒计时
-->
<template>
  <!--<div class="down_time">
    <div class="group" v-for="(item,index) in list" :key="index">
      <div :style="style" class="item" v-for="num in [0,1]" :key="num">
        <span>{{item.charAt(num)}}</span>
      </div>
    </div>
  </div>-->
  <p v-if="list[0]!='0' || list[1]!='0' || list[2]!='0'">
    <span class="tx">{{list[2]}}秒</span>
    <span class="tx">{{list[1]}}分:</span>
    <span class="tx">{{list[0]}}时:</span>
    <span class="tx" style="color:black">&nbsp;距开奖:</span>
  </p>
</template>

<script>

  export default {
    name: "index",
    props: {
      remain_time: Number,
      block_time: Number,
      styles: {
        type: Object,
        default: () => ({})
      },
      next_phase: {
        type: String,
        default: ''
      }
    },
    watch: {
      // 剩余时间被更新
      remain_time() {
        this.start();
      }
    },
    computed: {
      remain_time_diff() {
        return this.remain_time - this.block_time;
      },
      style() {
        return {
          width: '45px',
          height: '45px',
          backgroundColor: '333333',
          ...this.styles
        }
      }
    },
    data() {
      return {
        list: ['0', '0', '0']
      };
    },
    mounted() {
      this.start();
    },
    methods: {
      clear() {
        clearInterval(this._timer);
      },
      c_time(res) {
        if (isNaN(res)) return ['0', '0', '0'];

        const n = num => (num < 10 ? '' : '') + num;
        const hours = Math.floor(res / 3600);
        const minus = Math.floor(res / 60) % 60;
        const sec = res % 60;
        return [
          n(hours),
          n(minus),
          n(sec)
        ]
      },

      start() {
        let res = parseInt(this.remain_time)+1;
        this.clear();

        const run = async () => {

          // 没有倒计时时间
          if (res <= 0) {
            this.clear();
            return;
          }

          res--;

          res = res < 0 ? 0 : res;

          const fp = res - this.remain_time_diff;

          // 结束时外部展示封盘
          this.$emit('change', {
            time: fp < 0 ? 0 : fp
          });

          this.list = this.c_time(res);

          // 结束倒计时
          if (res === 0) {

            this.clear();

            // 封盘倒计时
            // const count = this.remain_time_diff;
            // 开始封盘倒计时
            // this.$emit('before_end', this);
            // await this.remain_time_down(count);

            // 结束封盘倒计时
            this.$emit('end', this);
            this.start();
          }

        };

        clearInterval(this._timer);
        this._timer = setInterval(run, 1000);
      },
      img(num) {
        return this.images[num];
      }
    },
    beforeDestroy() {
      this.clear();
    }
  }
</script>

<style lang="stylus" scoped>
@media screen and (max-width: 900px) {
  .down_time .item{width:24px !important;height:24px !important;line-height:24px !important}
  .down_time .item span{font-size:12px !important;}
  }
  .down_time {
    font-size: 0px;
    vertical-align: top;
    display: flex;
    justify-content: space-between;

    .group {
      display: inline-block;
      white-space: nowrap;
      vertical-align: top;

      .item {
        line-height: 46px;
        display: inline-block;
        white-space: nowrap;
        vertical-align: top;
        background #333;
        background: linear-gradient(#3e1801 0%, #160a00 60%, #311500 100%);
        text-align center;
        margin: 0 5px;
        position: relative;
        z-index: 2;
        border-radius: 4px;

        &:after {
          content: '';
          position absolute
          left: 0;
          top: 50%;
          right: 0;
          background: #3b281a;
          height: 2px;
          z-index: -1;
        }
        span {
          font-size: 46px;
          height:45px;
          display:block;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(0deg, #ed43b6 0%, #27c2dd 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/down-time/index.vue